import React from 'react'
import Button from '../button/button'
import { faLock, faUnlock } from '@fortawesome/free-solid-svg-icons'
import Icon, { IconType } from '../icon/icon'

function ProtectButton({
    isProtected,
    setIsProtected

}) {
  return (
    <Button
        onClick={()=>setIsProtected(!isProtected)}
    >
        {isProtected ? <Icon icon={IconType.LOCK}/> : <Icon icon={IconType.UNLOCK}/>}
    </Button>
  )
}

export default ProtectButton